/* eslint-disable @typescript-eslint/naming-convention */

import createSvgIcon from '../Utils/CreateSvgIcon';

export const Switzerland = createSvgIcon(
  <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_11441_205390)">
      <rect width="20" height="16" fill="#FF0400" />
      <path
        d="M18.0952 0H1.90476C0.852791 0 0 0.955126 0 2.13333V13.8667C0 15.0449 0.852791 16 1.90476 16H18.0952C19.1472 16 20 15.0449 20 13.8667V2.13333C20 0.955126 19.1472 0 18.0952 0Z"
        fill="#FF0400"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.5715 6.39995H5.71436V9.59995H8.5715V12.8H11.4286V9.59995H14.2858V6.39995H11.4286V3.19995H8.5715V6.39995Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_11441_205390">
        <rect width="20" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>,

  'Switzerland',
  '-2 -4 24 24',
);
